var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/~/lodash/_Symbol.js
// module id = 53
// module chunks = 0